import { Navigate, useParams } from "react-router-dom";
import Breadcrumbs from "../components/shared/Breadcrumbs";
import Seo from "../components/shared/Seo";
import Badge from "../components/ui/Badge";
import Button from "../components/ui/Button";
import LoadingState from "../components/ui/LoadingState";
import NoticeBanner from "../components/ui/NoticeBanner";
import SectionHeading from "../components/ui/SectionHeading";
import useContentResource from "../hooks/useContentResource";
import {
  createBreadcrumbSchema,
  createSoftwareApplicationSchema,
} from "../seo/schema";
import { buildCanonicalUrl } from "../seo/siteConfig";
import { getAppBySlug } from "../services/content/apps.service";

function AppDetailPage() {
  const { slug } = useParams();
  const appState = useContentResource(
    ({ signal }) => getAppBySlug(slug, { signal }),
    [slug]
  );
  const app = appState.data;

  if (appState.loading) {
    return <LoadingState title="Proje detayi yukleniyor..." />;
  }

  if (!app) {
    return <Navigate replace to="/myappshop" />;
  }

  return (
    <div className="page-stack">
      <Seo
        title={`${app.name} Proje Detayi`}
        description={app.description}
        path={`/myappshop/${app.slug}`}
        keywords={[app.category, ...app.platform, ...app.tags]}
        schema={[
          createSoftwareApplicationSchema(app),
          createBreadcrumbSchema([
            { name: "Anasayfa", url: buildCanonicalUrl("/") },
            { name: "MyAppShop", url: buildCanonicalUrl("/myappshop") },
            {
              name: app.name,
              url: buildCanonicalUrl(`/myappshop/${app.slug}`),
            },
          ]),
        ]}
      />
      {appState.usedFallback ? (
        <NoticeBanner>
          Bu proje kaydi local fallback kaynagindan geliyor. WordPress custom
          post type baglantisi hazir oldugunda ayni detay sayfasi API verisiyle
          beslenecek.
        </NoticeBanner>
      ) : null}
      <section className="glass-panel page-hero">
        <Breadcrumbs
          items={[
            { name: "Anasayfa", path: "/" },
            { name: "MyAppShop", path: "/myappshop" },
            { name: app.name, path: `/myappshop/${app.slug}` },
          ]}
        />
        <div className="meta-row">
          <Badge tone="accent">{app.status}</Badge>
          <Badge>{app.category}</Badge>
          {app.platform.map((item) => (
            <Badge key={item}>{item}</Badge>
          ))}
        </div>
        <SectionHeading title={app.name} description={app.description} />
      </section>

      <section className="content-section split-panel">
        <article className="glass-panel narrative-panel">
          <h3 className="panel-title">Kisa ozet</h3>
          <p>{app.summary}</p>
          <div className="tag-row">
            {app.tags.map((item) => (
              <span key={item} className="tag-pill">
                {item}
              </span>
            ))}
          </div>
        </article>

        <article className="glass-panel cta-panel">
          <h3 className="panel-title">Link alanlari</h3>
          <p>Store ve demo linkleri icin alanlar production yapisina uygun sekilde hazir.</p>
          <div className="hero-actions">
            <Button href={app.storeUrl} variant="primary">
              Store
            </Button>
            <Button href={app.demoUrl} variant="secondary">
              Demo
            </Button>
          </div>
        </article>
      </section>
    </div>
  );
}

export default AppDetailPage;
